<app-products-top></app-products-top>
<div class="max-w-screen-2xl mx-auto">
  <app-pyg-offering></app-pyg-offering>

  <!-- Innovation Teaser -->
  <section class="w-10/12 sm:w-9/12 mx-auto mb-20">
    <div class="pygInnovationTeaser p-8 sm:p-12 flex flex-col lg:flex-row items-center gap-8">
      <div class="flex-1">
        <h3 class="pb-3">{{ "solutions_page.custom_title" | translate }}</h3>
        <p class="pb-6">{{ "solutions_page.custom_text" | translate }}</p>
        <a langRouterLink="innovation" class="pygTeaserLink">
          {{ "solutions_page.custom_cta" | translate }}
        </a>
      </div>
      <div class="flex-shrink-0 text-[#602bc6]">
        <ng-icon name="iconoirLightBulb" class="text-7xl"></ng-icon>
      </div>
    </div>
  </section>

  <app-subscribe [place]="'products page'"></app-subscribe>
</div>
<app-try-demo></app-try-demo>
